<template>
  <v-container fluid>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <tenant-form />
  </v-container>
</template>

<script>
import TenantForm from './_Form'

export default {
  name: 'DriverMasterTenantEdit',
  components: {
    TenantForm
  },
  data () {
    return {
      breadcrumbs: [
        { text: '契約情報', disabled: false, to: '/driver/masters/tenants', exact: true },
        { text: '契約情報編集', disabled: true, to: '' },
      ],
    }
  },
  created() {
  },
  methods: {}
}
</script>
